// 3rd party
import React, { ReactElement } from 'react';
import styled from 'styled-components';

// Components
import FileViewer from 'common/components/FileViewer';
import CustomLoader from 'components/CustomLoader';

// Styling
const Container = styled.div`
  width: 100%;
  height: 100%;
  // margin-bottom: -10rem;
`;

// Props
interface Props {
  orderId?: string;
  orderUrl?: string;
}

const CartOrderReview = ({ orderUrl }: Props): ReactElement => {
  return orderUrl ? (
    <Container>
      <FileViewer height='100%' previewUrl={orderUrl}/>
    </Container>
  ) : (
    <CustomLoader size='4rem' padding='3rem' />
  );
};

export default CartOrderReview;
